import React, { useContext, useState } from 'react';
import { useDetectClickOutside } from 'react-detect-click-outside';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { routes } from 'consts';
import { Context } from 'context/Context';
import {
  EnelXGuiAtoms,
  EnelXGuiComponents,
  EnelXGuiConsts,
  EnelXGuiUtils,
} from 'gui';

import SidebarWrapper from 'components/SidebarWrapper';

const { MigrationButton } = EnelXGuiAtoms;
const { MigrationUserIcon, MigrationMainSidebar } = EnelXGuiComponents;

const {
  COLOR_PRIMARY_BASE,
  COLOR_TERTIARY_BASE,
  COLOR_WHITE,
  USER_SIDEBAR_ID,
} = EnelXGuiConsts;

const {
  getDsyTokenValue,
} = EnelXGuiUtils;

const UserSidebar = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const {
    api, user: { firstName, lastName },
  } = useContext(Context);

  const primaryColor = getDsyTokenValue(COLOR_PRIMARY_BASE);

  const [showSidebar, setShowSidebar] = useState(false);

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const ref = useDetectClickOutside({
    onTriggered: () => setShowSidebar(false),
  });

  const entries = [
    {
      name: firstName,
      surname: lastName,
    },
    {
      title: 'changePassword',
      icon: 'lock',
      link: routes.changePassword.root,
    },
  ];

  const render = () => (
    <SidebarWrapper>
      {entries.map(({
        title,
        icon,
        link,
        imageUrl,
        name,
        surname,
      }) => (
        <div
          key={`${title}-${link}`}
          slot="custom-list-element"
          className={`m-2 mb-3 ${link ? 'cursor-pointer' : ''}`}
          style={{ color: primaryColor }}
          onClick={() => {
            if (link) {
              setShowSidebar(false);
              history.push(link);
            }
          }}
        >
          {icon ? (
            <MigrationUserIcon
              backgroundColor={imageUrl ? getDsyTokenValue(COLOR_TERTIARY_BASE) : 'transparent'}
              icon={imageUrl ? undefined : icon}
              iconLibrary={imageUrl ? undefined : 'material'}
              imageUrl={imageUrl ?? undefined}
              isFullNameVisible
              name={name ?? t(`navigation.${title}`)}
              surname={surname || ''}
            />
          ) : (
            <MigrationUserIcon
              isFullNameVisible
              name={name ?? t(`navigation.${title}`)}
              surname={surname || ''}
            />
          )}
        </div>
      ))}
      <MigrationButton
        style={{
          alignSelf: 'center',
          marginTop: '1em',
        }}
        btnSize="compact"
        btnText={t('navigation.logout')}
        btnType="primary"
        onClick={async () => {
          await api.auth?.logout();
        }}
        btnShape="square"
      />
    </SidebarWrapper>
  );

  return (
    <div ref={ref}>
      <MigrationUserIcon
        name={firstName}
        surname={lastName}
        iconAndInitialsColor={getDsyTokenValue(COLOR_WHITE)}
        backgroundColor={getDsyTokenValue(COLOR_TERTIARY_BASE)}
        onClick={() => {
          setShowSidebar(!showSidebar);
          const newUserMenuState = !showSidebar;
          if (newUserMenuState) setShowSidebar(!showSidebar);
        }}
      />
      <MigrationMainSidebar
        close={toggleSidebar}
        defaultHeaderContent={false}
        isShown={showSidebar}
        noDefaultInternalPadding
        render={render}
        top="64px"
        width="17rem"
        id={USER_SIDEBAR_ID}
      />
    </div>
  );
};

export default UserSidebar;
